import { getBackVersion } from '../config';
import { PointStatementSnapshot } from '../models';
import api from './api';

const toSnapshot = ({
    ...pointStatement
}: PointStatementSnapshot): PointStatementSnapshot => {
    return {
        ...pointStatement,
        pointStatementId:
            pointStatement.transactionSource + '_' + pointStatement.id,
    };
};

const mapToSnapshot = (response: PointStatementSnapshot[]) =>
    response.map(toSnapshot);

const getPointStatements = (): Promise<PointStatementSnapshot[]> => {
    return api
        .request<PointStatementSnapshot[]>({
            method: 'GET',
            url: `${getBackVersion()}/agent/point_statement`,
        })
        .then(mapToSnapshot);
};

export default { getPointStatements };
